<template>
  <div class="developer-information bg-background pb-4 flex-grow-1">
    <div
      class="mb-4 description d-flex justify-content-center text-center text-white align-items-center"
    >
      <h1>{{ hebrew ? "מפתחים" : "Developers" }}</h1>
    </div>
    <b-container>
      <span v-for="(item, index) in developmentItems" :key="index">
        <dicta-publication :publicationItem="item"></dicta-publication>
      </span>
    </b-container>
  </div>
</template>
<script>
import DictaPublication from "@/components/dictaPublication"
export default {
  name: "Developers",
  components: {
    DictaPublication,
  },
  data() {
    return {
      developmentItems: [
        {
          name: "Dicta-LM 3.0",
          nameHE: "Dicta-LM 3.0",
          date: "01/12/2025",
          link: "/dicta-lm-3",
          text: "Dicta-LM 3.0: Advancing The Frontier in Hebrew Sovereign LLMs",
          textHE: "Dicta-LM 3.0: Advancing The Frontier in Hebrew Sovereign LLMs",
          authors: "Dicta Team",
          authorsHE: "Dicta Team",
        },
        {
          name: "Training Sovereign LLMs with NVIDIA Nemotron",
          nameHE: "אימון מודלי שפה ריבוניים עם NVIDIA Nemotron‏",
          date: "09/11/2025",
          link: "/nemotron-blog",
          text: "Training Sovereign LLMs with NVIDIA Nemotron and NVIDIA DGX Cloud Lepton",
          textHE: "אימון מודלי שפה ריבוניים עם NVIDIA Nemotron ו-NVIDIA DGX Cloud Lepton",
          authors: "Shaltiel Shmidman, Amit Bleiweiss, Oleg Sudakov, Meriem Bendris, Asher Fredman",
          authorsHE: "Shaltiel Shmidman, Amit Bleiweiss, Oleg Sudakov, Meriem Bendris, Asher Fredman",
        },
        {
          name: "Dicta LM",
          nameHE: "Dicta LM",
          date: "16/04/2024",
          link: "/dicta-lm",
          text: "Dicta-LM 2.0 - A large, open, and powerful generative language model in Hebrew!",
          textHE: "Dicta-LM 2.0 - מודל שפה גנרטיבי גדול בעברית, פתוח, וחזק!",
          authors: "Dicta Team",
          authorsHE: "צוות דיקטה",
        },
        {
          name: "Dicta BERT",
          nameHE: "Dicta BERT",
          date: "29/12/2023",
          link: "/dicta-bert",
          text: "DictaBERT: A State-of-the-Art BERT Suite for Modern Hebrew",
          textHE: "DictaBERT: חבילת BERT חדישה לעברית מודרנית",
          authors: "Dicta Team",
          authorsHE: "צוות דיקטה",
        },
      ],
    }
  },
  computed: {
    hebrew() {
      return this.$settings.hebrew
    },
  },
}
</script>
